import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';
import { CssClassMapping } from '../../../../core/configuration/css-class-mapping';
import { ServicePathsSettings } from '../../../../core/configuration/service-paths-settings';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { ServicesSearch } from '../../../../search/services/search.service';
import { MappingTipiEntitaPratica } from "../../../configuration/mapping-tipi-entita-pratica";
import { FascicoloFullResponse } from '../../../models/dto/fascicolo-full-response';
import { SearchRequest } from '../../../models/dto/search-request';
import { SearchResponse } from '../../../models/dto/search-response';
import { FascicoloMap } from '../../../models/fascicolo-map';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { FascicoloGiudiziale } from '../../../models/fascicolo/fascicolo-giudiziale';
import { FascicoloLight } from '../../../models/fascicolo/fascicolo-light';
import { PraticaBase } from '../../../models/pratica/pratica-base';
import { PraticaLight } from '../../../models/pratica/pratica-light';
import { AutoritaGiudiziaria } from '../../../models/tipologiche/autorita-giudiziaria';
import { Materia } from '../../../models/tipologiche/materia';
import { Oggetto } from '../../../models/tipologiche/oggetto';
import { SedeTerritoriale } from '../../../models/tipologiche/sede-territoriale';
import { TipoFascicolo } from '../../../models/tipologiche/tipo-fascicolo';
import { TipoPratica } from '../../../models/tipologiche/tipo-pratica';
import { RiunioneGiudiziModEdit } from '../../pratica/pratiche-riunite/riunione-giudizi-mod-edit';
import { RiunioneRequest } from '../../pratica/pratiche-riunite/riunione-request';
import { FascicoloFullAdapter } from './fascicolo-full-adapter';
import { FascicoloGiudizialeAdapter } from './fascicolo-giudiziale-adapter';
import { RequestSearchRiunisci } from './request-search-riunisci';

declare var getFascicoloMapSync;
declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [riunisci-giudizi]',
  templateUrl: 'riunisci-giudizi.component.html',
  styleUrls: ['./riunisci-giudizi.component.css'],
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class RiunisciGiudiziComponent {

  @Output() onReturn: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('modalRiunioneGiudiziEdit') riunioneGiudiziModEdit: RiunioneGiudiziModEdit;

  // form
  riunioneGiudiziForm: FormGroup;
  requestRiunione: RiunioneRequest;

  // options
  autoritaGiudiziariaOptions: AutoritaGiudiziaria[] = [];
  autoritaGiudiziariaCittaOptions: SedeTerritoriale[] = [];
  materiaOptions: Materia[] = [];
  oggettoOptions: Oggetto[] = [];
  tipiPratica: TipoPratica[] = new Array<TipoPratica>();
  tipiFascicolo: TipoFascicolo[] = new Array<TipoFascicolo>();
  oggettiFilter: string;
  tipiFascicoloFilter: string;
  // variabili per ricerca
  searchForm: FormGroup;
  searchRequest: SearchRequest = new SearchRequest();
  requestSearchRiunisci: RequestSearchRiunisci;
  waitResponseSearch: boolean = false;
  listPraticheFromSearch: PraticaBase[] = [];
  listFascicoliFromSearch: FascicoloFullAdapter[] = [];
  praticheTotali: number = 0;
  msgRicercaEmpty: string = '';

  // variabili
  fascicoloRequest: FascicoloGiudizialeAdapter;
  fascicolo: FascicoloFull;
  fascicoloMap: FascicoloMap;
  pratica: PraticaBase;

  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();
  ID_PRATICA_PARERISTICA = MappingTipiEntitaPratica.PRATICA_PARERISTICA;

  lastSearchFilters: any = null;

  constructor(protected operationService: OperationsService,
              protected helpers: HelpersService,
              private servicesSearch: ServicesSearch,
              private http: HttpClient,
              private campiForm: FormBuilder) {}

  inizializza(_fascicolo: FascicoloLight, _praticaBase: PraticaBase) {
    let idTipoFascicolo = _fascicolo.tipoFascicolo.id;
    let idTipoPratica = _praticaBase.tipoPratica.id;
    this.fascicoloMap = this.getFascicoloFromMap(idTipoFascicolo, idTipoPratica);
    this.pratica = _praticaBase;
    this.listPraticheFromSearch = [];
    this.listFascicoliFromSearch = [];
    this.fascicolo = null;
    this.fascicoloRequest = null;
    this.waitResponseSearch = true;
    this.oggettiFilter = "ALL";
    this.tipiFascicoloFilter = "ALL";
    this.operationService.readFascicolo(this.fascicoloMap.pathView, _fascicolo.id ).subscribe(response => this.readFascicolo(response));
  }

  initRequest() {
    this.msgRicercaEmpty = '';
    this.requestSearchRiunisci = new RequestSearchRiunisci(this.fascicolo);
    this.requestRiunione = new RiunioneRequest();
    this.requestRiunione.fascicoloCapofila = <FascicoloGiudiziale>this.fascicoloRequest;
    this.populateSelect();
  }

  populateSelect() {
    this.helpers.getTipiPratica().subscribe(response => this.tipiPratica = response);
    this.helpers.getTipiFascicolo(this.tipiFascicoloFilter).subscribe(response => this.tipiFascicolo = response);
    this.helpers.getMateria().subscribe(response => this.materiaOptions = response);
    this.helpers.getOggetti(this.oggettiFilter).subscribe(response => this.oggettoOptions = response);

  }

  createForm() {
    this.initRequest();
    this.createSearchForm();
    this.createRiunioneGiudiziForm();
  }

  private readFascicolo(response: FascicoloFullResponse) {
    this.waitResponseSearch = false;
    if (response.returnCode === 'OK') {
      this.fascicoloRequest = new FascicoloGiudizialeAdapter(response.fascicolo);
      this.fascicolo = response.fascicolo;
      console.log(this.fascicolo);
      this.createForm();
    }
  }

  private createSearchForm() {
    this.searchForm = this.campiForm.group({
      materia: [this.requestSearchRiunisci.searchCriteria.criteriUtente.criteriCustom['materia']],
      oggetto: [this.requestSearchRiunisci.searchCriteria.criteriUtente.criteriCustom['oggetto']],
      giudice: [this.requestSearchRiunisci.searchCriteria.criteriUtente.criteriCustom['giudice']],
      dataUdienza: [this.requestSearchRiunisci.searchCriteria.criteriUtente.criteriCustom['dataUdienza']],
      dataInizioFascicoloDal: [this.requestSearchRiunisci.searchCriteria.inizioFascicoloDataDa],
      dataInizioFascicoloAl: [this.requestSearchRiunisci.searchCriteria.inizioFascicoloDataA],
      nomeControparte: [this.requestSearchRiunisci.searchCriteria.criteriUtente.criteriCustom['nomeControparte']],
      cognomeControparte: [this.requestSearchRiunisci.searchCriteria.criteriUtente.criteriCustom['cognomeControparte']],
      posizione: [this.requestSearchRiunisci.searchCriteria.posizionePratica],
      numeroRuolo: [this.requestSearchRiunisci.searchCriteria.criteriUtente.criteriCustom['numeroRuolo']],
      tipoPratica: [this.requestSearchRiunisci.searchCriteria.tipoPratica],
      tipoFascicolo: [this.requestSearchRiunisci.searchCriteria.criteriUtente.criteriCustom['tipoFascicolo']]
    });
  }

  private createRiunioneGiudiziForm() {
    this.riunioneGiudiziForm = this.campiForm.group({
      dataRiunione: [this.requestRiunione.dataRiunione, Validators.required],
      motivoRiunione: [this.requestRiunione.motivoRiunione, Validators.required]
    });
  }

  searchPratiche() { // submit ricerca

    this.listPraticheFromSearch = [];
    this.listFascicoliFromSearch = [];
    this.praticheTotali = 0;
    this.waitResponseSearch = true;

    const numeroRuolo = this.requestSearchRiunisci.searchCriteria.criteriUtente.criteriCustom['numeroRuolo'].value;
    const cognomeControparte = this.requestSearchRiunisci.searchCriteria.criteriUtente.criteriCustom['cognomeControparte'].value;
    const posizione = this.requestSearchRiunisci.searchCriteria.posizionePratica;

    this.requestSearchRiunisci.searchCriteria.criteriUtente.criteriCustom['numeroRuolo'].value = numeroRuolo && numeroRuolo.trim() !== ''
      ? this.requestSearchRiunisci.searchCriteria.criteriUtente.criteriCustom['numeroRuolo'].value
      : null;

    this.requestSearchRiunisci.searchCriteria.criteriUtente.criteriCustom['cognomeControparte'].value = cognomeControparte && cognomeControparte.trim() !== ''
      ? this.requestSearchRiunisci.searchCriteria.criteriUtente.criteriCustom['cognomeControparte'].value
      : null;

    this.requestSearchRiunisci.searchCriteria.posizionePratica = posizione && posizione.trim() !== ''
      ? this.requestSearchRiunisci.searchCriteria.posizionePratica
      : null;

    this.servicesSearch.searchRiuniti(<SearchRequest> this.requestSearchRiunisci)
      .subscribe(response => this.processRisultatiPratica(response, false));
  }

  private processRisultatiPratica(response: SearchResponse, emptyList: boolean) {
    if (response.returnCode === 'OK') {
      if (emptyList) {
        this.listPraticheFromSearch = [];
      }
      this.listPraticheFromSearch = this.listPraticheFromSearch.concat(response.pratiche);
      this.praticheTotali = Number(response.numeroPraticheTotali);
    }
    this.listFascicoliFromSearch = this.listFascicoliFromSearch.concat(this.estraiFascicoliFromPraticheList(response.pratiche));
    if (this.listFascicoliFromSearch.length === 0) {
      this.msgRicercaEmpty = 'La ricerca non ha prodotto nessun risultato';
    }else {
      this.msgRicercaEmpty = '';
    }
    this.waitResponseSearch = false;
  }

  reloadSearch() { // carica altri risultati
    this.waitResponseSearch = true;
    this.requestSearchRiunisci.fromResult = this.listPraticheFromSearch.length;
    this.servicesSearch.search(<SearchRequest>this.requestSearchRiunisci).subscribe(response => this.processRisultatiPratica(response, false));
  }

  private estraiFascicoliFromPraticheList(pratiche: PraticaLight[]): FascicoloFullAdapter[] {
    let fascicoli: FascicoloFullAdapter[] = [];
    for (let i = 0; i < pratiche.length; i++) {
        if (pratiche[i].id !== this.fascicolo.praticaBase.id) { // la pratica ricercata non pu� essere uguale a quella in elaborazione
          let praticaBase = new PraticaBase();
          praticaBase.tipoPratica = pratiche[i].tipoPratica;

          for (let fascicoloLight of pratiche[i].fascicoliLight) {
            let fascicoloFullAdapter: FascicoloFullAdapter = new FascicoloFullAdapter(fascicoloLight, pratiche[i]);
            fascicoli.push(fascicoloFullAdapter);
          }
        } else {
          this.praticheTotali = this.praticheTotali - 1;
        }
    }
    return fascicoli;
  }

  riunisciGiudizi() { // submit riunisci giudizi
    this.operationService.riunisciGiudizi( ServicePathsSettings.URL_RIUNISCI_GIUDIZI, this.requestRiunione ).
      subscribe(response => this.datiRiunisciGiudizi(response));
  }

  private datiRiunisciGiudizi(response: FascicoloFullResponse) {
    if (response.returnCode === 'OK') {
      closeModal('modalRiunisciGiudizi');
    }
    this.onReturn.emit(response.returnCode === 'OK');
  }

  private getFascicoloFromMap(idTipoFascicoloMap: any, idTipoPraticaMap: any) {
    // let nomeFascicoloFE = FrontEndMapping.tipiFascicolo[idTipoFascicoloMap];
    // let nomePraticaFE = FrontEndMapping.tipiPratica[idTipoPraticaMap];
    let fascicolo = getFascicoloMapSync(idTipoPraticaMap, idTipoFascicoloMap);
    return fascicolo;
  }

  getClassPratica(idTipoPratica) {
    return CssClassMapping.cssTipiPratica[idTipoPratica];
  }

  onCheckFascicolo(event, fascicolo) {
    let isChecked = event.target.checked;
    if (isChecked) {
      this.requestRiunione.fascicoliDaRiunire.push(fascicolo);
    }else {
      let indRemove = this.requestRiunione.fascicoliDaRiunire.findIndex(f => f.id === fascicolo.id);
      console.log(indRemove);
      if (indRemove >= 0) {
        this.requestRiunione.fascicoliDaRiunire.splice(indRemove, 1);
      }
    }
  }

  getCssClassCategoriaFascicolo(fascicolo: FascicoloFull) {
      let categoriaMap = CssClassMapping.cssTipiCategoriaFascicolo[fascicolo.tipoFascicolo.categoria.id];
      return categoriaMap;
    }

  getCssClassCategoriaFascicoloLight(fascicolo: FascicoloLight) {
    if(fascicolo.tipoFascicolo && fascicolo.tipoFascicolo.categoria){
      let categoriaMap = CssClassMapping.cssTipiCategoriaFascicolo[fascicolo.tipoFascicolo.categoria.id];
      return categoriaMap;
    }
  }

  onSelectMateria(materia:Materia) {
    this.searchForm.controls['oggetto'].disable({ onlySelf: true });
    if (materia) {
      this.oggettiFilter = materia.id;
      this.requestSearchRiunisci.searchCriteria.criteriUtente.criteriCustom['materia'].value = materia.id;
      this.helpers.getOggetti(this.oggettiFilter).subscribe(response => this.oggettoOptions = response.sort((leftSide, rigthSide): number => {
        if (leftSide.label < rigthSide.label) return -1;
        if (leftSide.label > rigthSide.label) return 1;
        return 0;
      }));
      this.searchForm.controls['oggetto'].enable({ onlySelf: true });
    } else {
      this.oggettiFilter = "ALL";
      this.helpers.getOggetti(this.oggettiFilter).subscribe(response => this.oggettoOptions = response.sort((leftSide, rigthSide): number => {
        if (leftSide.label < rigthSide.label) return -1;
        if (leftSide.label > rigthSide.label) return 1;
        return 0;
      }));
      this.searchForm.controls['oggetto'].enable({ onlySelf: true });
    }
  }

  onSelectTipoPratica(tipoPratica: TipoPratica) {
    this.searchForm.controls['tipoFascicolo'].disable({ onlySelf: true });
    if (tipoPratica) {
      this.tipiFascicoloFilter = tipoPratica.id;
      this.requestSearchRiunisci.searchCriteria.tipoPratica = tipoPratica;
      this.helpers.getTipiFascicolo(this.tipiFascicoloFilter).subscribe(response => this.tipiFascicolo = response.sort((leftSide, rigthSide): number => {
        if (leftSide.label < rigthSide.label) return -1;
        if (leftSide.label > rigthSide.label) return 1;
        return 0;
      }));
      this.searchForm.controls['tipoFascicolo'].enable({ onlySelf: true });
    } else {
      this.tipiFascicoloFilter = "ALL";
      this.requestSearchRiunisci.searchCriteria.tipoPratica = tipoPratica;
      this.helpers.getTipiFascicolo(this.tipiFascicoloFilter).subscribe(response => this.tipiFascicolo = response.sort((leftSide, rigthSide): number => {
        if (leftSide.label < rigthSide.label) return -1;
        if (leftSide.label > rigthSide.label) return 1;
        return 0;
      }));
      this.searchForm.controls['tipoFascicolo'].enable({ onlySelf: true });
    }
  }

}
